import React, { Suspense } from 'react';
import { isMobile } from '@/biz/tool';
import WebModal from '../web/components/Modal';
import BottomDrawer from '../web/components/BottomDrawer';
import { useWebModalStore } from '@/hooks/useWebModalStore';
import { CloseIcon } from '@/components/common/icon';
import { useTranslation } from 'react-i18next';

// 将 IM 相关的内容移到一个单独的异步组件中
const AsyncImContent = React.lazy(() => import('./ImContent'));

interface Props {}

const ImModal: React.FC<Props> = () => {
  const { t } = useTranslation();
  const { isShowImModal, setShowImModal } = useWebModalStore();

  return (
    <>
      {isMobile() ? (
        <BottomDrawer
          title=""
          visible={isShowImModal}
          handleClose={() => setShowImModal(false)}
          isShowFooter={false}
          rootClassName="!z-[9999]"
        >
          {isShowImModal && (
            <Suspense
              fallback={
                <div className="h-[50vh]">
                  {t('common.loading', { defaultValue: 'Loading...' })}
                </div>
              }
            >
              <AsyncImContent />
            </Suspense>
          )}
        </BottomDrawer>
      ) : (
        <WebModal
          width={1100}
          title=""
          visible={isShowImModal}
          handleClose={() => setShowImModal(false)}
          isShowFooter={false}
          isShowHeader={false}
          style={{
            padding: 0
          }}
        >
          <>
            <div className="w-[1100px] px-6 py-4 border-b border-[#e8e8ec] inline-flex justify-between items-center">
              <div className="justify-start text-black text-xl font-bold font-['Plus_Jakarta_Sans'] leading-relaxed">
                {t('common.messages', { defaultValue: 'Messages' })}
              </div>
              <div
                className="w-6 h-6 relative cursor-pointer"
                onClick={() => setShowImModal(false)}
              >
                <CloseIcon className="w-[16px] h-[16px]" />
              </div>
            </div>
            {isShowImModal && (
              <Suspense
                fallback={<div className="h-[80vh]">{t('common.loading')}</div>}
              >
                <AsyncImContent />
              </Suspense>
            )}
          </>
        </WebModal>
      )}
    </>
  );
};

export default ImModal;
